export const DELIVERY_TYPES = {
  SLOW_AUTO: 'slow auto',
  RAPID_AUTO: 'rapid auto',
  AIRPLANE: 'airplane',
};
